import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AuthProvider } from 'auth';
import { ToastProvider } from 'my-account/toast';

import Wizard from 'tempcontrol/wizard';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

/**
 * Root for the public TempControl wizard. Mounted from `tempcontrol/index.tsx`
 * onto a `#tempcontrol-app-root` element rendered by the WordPress block.
 *
 * The wizard surface intentionally stays usable for anonymous visitors -
 * `AuthProvider` is wired in only so the wizard can *detect* the
 * already-existing my-account session if one is present, NOT to gate
 * access. For visitors without an auth cookie the provider settles
 * straight into `LoggedOut` (it skips `getCurrentUser()` entirely),
 * so anonymous flow keeps zero auth round-trips. For signed-in
 * visitors the provider lights up the History panel's "your projects"
 * source plus the "View all projects" link to the customer portal.
 *
 * Provider order mirrors `my-account/index.tsx` so `AuthProvider`
 * has access to `useToast`, `useLocation`, `useHistory`, and
 * `useQueryClient`.
 */
export const TempControlApp: React.VFC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <AuthProvider>
            <Wizard />
          </AuthProvider>
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

export default TempControlApp;
